<main class="did-create-page">
  <header class="page-header">
    <div class="title-block">
      <span class="eyebrow"><mat-icon>fingerprint</mat-icon>DID Manager</span>
      <h1>{{ 'did.create' | translate }}</h1>
      <p>Erstellen Sie eine did:web-Identität und verknüpfen Sie sie mit einem vertrauenswürdigen Zertifikat.</p>
    </div>
    <div class="header-actions">
      <button mat-button color="primary" type="button" (click)="backToOverview()">
        <mat-icon>arrow_back</mat-icon>
        {{ 'did.overview.title' | translate }}
      </button>
    </div>
  </header>

  <section class="create-workspace">
    <div class="form-workspace">
      <section class="form-intro">
        <span>01 · Identität</span>
        <h2>DID-Grunddaten</h2>
        <p>Die Bezeichnung hilft bei der späteren Zuordnung und ist nicht Teil der öffentlichen DID.</p>
      </section>

      <div class="label-field" [formGroup]="formGroup">
        <mat-form-field appearance="outline" subscriptSizing="dynamic">
          <mat-label>{{ 'did.label' | translate }}</mat-label>
          <mat-icon matPrefix>label</mat-icon>
          <input matInput id="label" formControlName="label"
            [placeholder]="'did.label_placeholder' | translate" autocomplete="off">
          <mat-hint>Interner Anzeigename, zum Beispiel „Produktions-Wallet“.</mat-hint>
        </mat-form-field>
      </div>

      <div class="section-divider"></div>

      <app-did-web-generator
        [label]="label.value"
        (labelChange)="label.setValue($event)"
        [embeddedMode]="embeddedMode"
        (didGenerated)="onDidGenerated()">
      </app-did-web-generator>
    </div>
  </section>
</main>
